import { beginRound } from "./appliers";
import type {
  InitGameOptions,
  LoveWinsAllPlayer,
  LoveWinsAllPlayerId,
  LoveWinsAllState,
} from "./types";
import { LOVE_WINS_ALL_PLAYERS, LOVE_WINS_ALL_START_CHIPS } from "./types";
import { fullDeck, shuffleDeck } from "./utils";

function createPlayer(playerId: LoveWinsAllPlayerId): LoveWinsAllPlayer {
  return { playerId, label: playerId === "p1" ? "선" : "후" };
}

export function initGame(options: InitGameOptions = {}): LoveWinsAllState {
  const firstLead = options.firstLeadPlayerId ?? "p1";
  if (!LOVE_WINS_ALL_PLAYERS.includes(firstLead)) {
    throw new Error("First lead player must be p1 or p2");
  }
  const seed = options.seed ?? 1;
  const shuffled = shuffleDeck(fullDeck(), seed);

  const base: LoveWinsAllState = {
    gameId:
      options.gameId ?? `love-wins-all-${LOVE_WINS_ALL_PLAYERS.join("-")}`,
    players: LOVE_WINS_ALL_PLAYERS.map(createPlayer),
    phase: "bet",
    round: 0,
    leadPlayerId: firstLead,
    currentPlayerId: firstLead,
    deck: shuffled.deck,
    hands: { p1: [], p2: [] },
    chips: {
      p1: LOVE_WINS_ALL_START_CHIPS,
      p2: LOVE_WINS_ALL_START_CHIPS,
    },
    pot: 0,
    contributed: { p1: 0, p2: 0 },
    raisesUsed: 0,
    lastAggressorId: null,
    rngState: shuffled.state,
    lastRound: null,
    winnerId: null,
    lastAction: null,
    moveNumber: 0,
  };

  // Deal the first round's hands, pay antes, and open the betting.
  return beginRound(base);
}
